import { ChatMessageForWS } from "./chatMessage";

export enum WebsocketMessagesTypes {
  NEW_MESSAGE = "NEW_MESSAGE",
  MESSAGE_READ = "MESSAGE_READ",
  MESSAGE_UPDATE = "MESSAGE_UPDATE",
  CHAT_STATUS_UPDATE = "CHAT_STATUS_UPDATE",
  USER_IS_WRITING = "USER_IS_WRITING",
  CLAIMS_UPDATE = "CLAIMS_UPDATE",
  CLAIM_UPDATE = "CLAIM_UPDATE",
  NOTIFICATIONS_UPDATE = "NOTIFICATIONS_UPDATE",
  CLAIM_MESSAGES = "CLAIM_MESSAGES",
  CLAIM_FILE_PREVIEW_READY = "CLAIM_FILE_PREVIEW_READY",
  CLAIM_UNREAD_COUNT = "CLAIM_UNREAD_COUNT",
}

export interface WebsocketMessageData {
  msg_type: WebsocketMessagesTypes;
  data: ChatMessageForWS | any;
}
